export default {
    listagem: {
        titulo_pagina: 'List of Credentials',
        novo: 'Create New Credential',
        table: {
            empty: 'No Credentials Found',
            nome: 'Name',
            empresa: 'Company',
            usuario: 'User',
            homologacao: 'Homologation',
            classe: 'Class',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Credential',
            editar: 'Edit Credencial'
        },
        fields: {
            nome: {
                label: 'Name',
                description: 'Credential Name'
            },
            empresa: {
                label: 'Company',
                description: 'Company to which the credential belongs'
            },
            usuario: {
                label: 'User Name',
                description: 'Name that will be used on the credential'
            },
            senha: {
                label: 'Password',
                description: 'Password that will be used in the credential'
            },
            entidade: {
                label: 'Entity',
                description: 'Entity that will be used in the credential'
            },
            homologacao: {
                label: 'Homologation',
                description: 'Active or inactive status of the credential in Homologation'
            },
            status: {
                label: 'Status',
                description: 'Credential active or inactive status'
            },
            botao_salvar : 'Save Credencial'
        },
        create: {
            success: 'Credential created successfully!',
            error: 'Error creating credential!'
        },
        update: {
            success: 'Credential successfully edited!',
            error: 'Error editing credential!'
        }
    }
}
